import { constructTime, constructDate } from './date-formatting-helper';

function roundTimeToNearest15Mins(date) {
  const coeff = 1000 * 60 * 15;
  return new Date(Math.round(date.getTime() / coeff) * coeff);
}

export function constructEtaValue(dateIso, destination) {
  if (!dateIso) return '';

  const date = new Date(dateIso);

  const { timeZone } = destination.where.facility;

  return `${constructDate(date, false, timeZone)}, ${constructTime(roundTimeToNearest15Mins(date), timeZone)} (${timeZone})`;
}
